var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.364 10.264a.6.6 0 00.853 0 .608.608 0 000-.856L6.27 5.443l3.994-4.014a.608.608 0 000-.856.6.6 0 00-.852 0L5.419 4.586 1.424.573a.6.6 0 00-.852 0 .608.608 0 000 .856l3.994 4.014L.62 9.408a.608.608 0 000 .856.6.6 0 00.853 0L5.419 6.3l3.945 3.964z",
    fill: "currentColor"
  })));
}
export default SvgClose;